__turbopack_context__.v({
  "className": "cormorant_garamond_391cc94f-module__kjOYmq__className",
});
